import { generateJSON, type JSONContent } from "@tiptap/core";
import OrderedList from "@tiptap/extension-ordered-list";
import { FULL_DOCUMENT_EXTENSIONS } from "../../../src/shared/schemas/tiptapSchemaProfiles";

const conversionExtensions = [...FULL_DOCUMENT_EXTENSIONS, OrderedList];

function normalizeOrderedLists(node: JSONContent): JSONContent[] {
  if (node.type === "orderedList") {
    const start = typeof node.attrs?.start === "number" ? node.attrs.start : 1;
    return (node.content ?? []).flatMap((item, index) => {
      const [first = { type: "paragraph" }, ...remaining] =
        (item.content ?? []).flatMap(normalizeOrderedLists);
      const content = [...(first.content ?? [])];
      const marker = `${start + index}. `;
      if (content[0]?.type === "text" && !content[0].marks?.length) {
        content[0] = { ...content[0], text: marker + content[0].text };
      } else {
        content.unshift({ type: "text", text: marker });
      }
      return [
        { ...first, content },
        ...remaining,
      ];
    });
  }
  return [{ ...node, ...(node.content ? { content: node.content.flatMap(normalizeOrderedLists) } : {}) }];
}

/** Keep card formatting in the document's existing schema. Numbered lists use
 * literal numbered paragraphs, matching the editor's paste convention. */
export function buildSuggestionDocumentContent(renderedHtml: string): { default: JSONContent } {
  const parsed = generateJSON(renderedHtml, conversionExtensions);
  return { default: normalizeOrderedLists(parsed)[0] };
}
